var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPointsMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 16,
    viewBox: "0 0 5 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.31052 3.92401C3.37048 3.92401 4.23773 3.05676 4.23773 1.9968C4.23773 0.936827 3.37048 0.0695801 2.31052 0.0695801C1.25055 0.0695801 0.383301 0.936827 0.383301 1.9968C0.383301 3.05676 1.25055 3.92401 2.31052 3.92401ZM2.31052 5.85123C1.25055 5.85123 0.383301 6.71847 0.383301 7.77844C0.383301 8.83841 1.25055 9.70566 2.31052 9.70566C3.37048 9.70566 4.23773 8.83841 4.23773 7.77844C4.23773 6.71847 3.37048 5.85123 2.31052 5.85123ZM2.31052 11.6329C1.25055 11.6329 0.383301 12.5001 0.383301 13.5601C0.383301 14.6201 1.25055 15.4873 2.31052 15.4873C3.37048 15.4873 4.23773 14.6201 4.23773 13.5601C4.23773 12.5001 3.37048 11.6329 2.31052 11.6329Z",
    fill: "#9A9AB0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointsMenu);
export default __webpack_public_path__ + "static/media/points_menu.0337e1c19d70bc4d636e096196855a8e.svg";
export { ForwardRef as ReactComponent };